import { withFormElement } from "@brynlabs/webforms-react"
import classNames from "classnames"
import PropTypes from "prop-types"
import React from "react"

import "./checkbox.sass"

class Checkbox extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      value: this.props.checked || false,
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.checked !== prevProps.checked) {
      this.setState({ value: this.props.checked || false })
    }
  }

  onChange(value) {
    this.setState({ value })
    if (this.props.onChange) {
      this.props.onChange(value)
    }
  }

  render() {
    const {
      translatedLabel,
      darkAppearance,
      large,
      disabled,
      required = false,
    } = this.props

    return (
      <div
        className={classNames(
          "_fp-checkbox",
          { "_fp-checkbox--dark": darkAppearance },
          { "_fp-checkbox--disabled": disabled },
          { "_fp-checkbox--required": required },
          { "_fp-checkbox--large": large },
        )}
      >
        <label className={"_fp-checkbox__label"}>
          <input
            className={"_fp-checkbox__input"}
            type="checkbox"
            checked={this.state.value}
            onChange={(ev) => this.onChange(ev.target.checked)}
            required={required}
            aria-required={required}
            disabled={disabled}
          />
          <span className={"_fp-checkbox__checkbox"} />
          <div className="_fp-checkbox__label__text">{translatedLabel}</div>
        </label>
      </div>
    )
  }
}

Checkbox.propTypes = {
  darkAppearance: PropTypes.bool,
  large: PropTypes.bool,
  translatedLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
    .isRequired,
  checked: PropTypes.bool,
  required: PropTypes.bool,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
}

const WebformsCheckbox = withFormElement(({ setData, getData, ...props }) => {
  return (
    <Checkbox
      onChange={(checked) => setData(checked)}
      checked={getData()}
      {...props}
    />
  )
})

export { Checkbox, WebformsCheckbox }
